export default "__VITE_PUBLIC_ASSET__d6add3f5__"